export const USER_AVATAR =
  "https://scontent.fktm10-1.fna.fbcdn.net/v/t39.30808-6/339248873_176759608566738_5772653231604298843_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=5f2048&_nc_ohc=Km5O93XXVLQAX-YijAs&_nc_ht=scontent.fktm10-1.fna&oh=00_AfC9HDTVw3VJ0CdoDgLqlogqEwxi005a493kkLLwo8gv3A&oe=65605AB6";
export const API_OPTIONS = {
  method: "GET",
  headers: {
    accept: "application/json",
    Authorization:
      "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIwZDFlYzQwM2EwZWUzNTc5NjU0YzhlNjY0MjUxNmVmMSIsInN1YiI6IjY1NTRiYWNlNjdiNjEzNDVjZDM0MzU2YSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.P1SCDCpLhRyldPsBw7kPRge7XV3mx4fdtREst2awjCY",
  },
};

export const MOVIE_IMAGE_CDN = "https://image.tmdb.org/t/p/w500";

export const BG_IMAGE =
  "https://assets.nflxext.com/ffe/siteui/vlv3/77d35039-751f-4c3e-9c8d-1240c1ca6188/9e7e0ebe-cd77-49ac-8bf3-d1fb691d0ece/NP-en-20231106-popsignuptwoweeks-perspective_alpha_website_large.jpg";

